import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { User } from '../models/auth.models';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class UserProfileService {
    constructor(private http: HttpClient) { }
    
    /***
     * Get All User
     */
    getAll() {
        return this.http.get<User[]>(`api/users`);
    }
    
    /***
     * Get User Names and Emails
     */
    getUserNamesAndEmails(): Observable<any> {
        return this.http.get<any>(`${environment.main_url}/agilelegal/user/names-emails`)
            .pipe(
                catchError(error => {
                    console.error('Error fetching user names and emails:', error);
                    return [];
                })
            );
    }

    /***
     * Facked User Register
     */
    register(user: User) {
        return this.http.post(`/users/register`, user);
    }
}